export default {
    title: "Activate Your Teacher Account Now and Earn E-Vouchers!",
    joinedTitle: "You have successfully joined the teacher account update campaign!",
    joinedMessage: "📧 After completion and verification by EdCity, your reward is expected to be sent to your school email inbox within a few weeks. Thank you for your patience.​",
    referralCode: "Your referral code: ",    
    numberOfReferrals: "Number of successful referrals: ",
    components: {
        start: {
            description: "Complete the simple data verification process to join the campaign and earn e-vouchers. The process is quick and easy. Act now to unlock your exclusive teacher rewards!​",
            wrongAccountAlert: "You are currently logged in with a <b>individual teacher account</b>.<br>To participate in this campaign, please log in again with your <b>school-based teacher account</b>.<br> If you have forgotten your school-based account login details, please contact your school administrator.",
            requirement: {
                title: "Participation Requirements",
                list: [
                    "<b>Subscribe to EdCity’s Newsletters</b> – Tick at least one option",
                    "<b>Complete ‘Be a Teacher’ Information</b> – Three mandatory fields: Major Teaching Subjects, Major Duties, Areas of Interest",
                ]
            },
            reward: {
                title: "E-Voucher Mechanism",
                list: [
                    "Every teacher who completes the update: <b>$20 7-11 e-voucher​</b>",
                ]
            },
            referral: {
                title: "Referral Program​",
                list: [
                    "Receive a unique referral code after completing verification​",
                    "For every <b>3</b> successful referrals, earn an additional <b>$10 7-11 e-voucher​</b>",
                    "Maximum referrals per teacher: <b>9</b> successful referrals (Maximum reward: $30)"
                ]
            },
            period:{
                title: "Campaign Period: ",
                list: [
                    "{startDate} to {endDate}"
                ]
            }
        },
        
        referral: {
            description: "Enter your referrer's referral code to enjoy the benefits. If you don't have a referral code, you can skip to the next step.",
            input: {
                referralCode: {
                    label: "Referral Code (Optional)",
                    error:{
                       improper: "The referral code is invalid, please re-enter.",
                       invalid: "The referral code format is incorrect, please check and try again.",
                    }   
                },
            }
        },
        subscription:{
            description: "Please select the EdCity information you would like to subscribe to. At least one option must be selected to continue participating in the campaign.",
        },        
        subjects:{
            description: "Please select the 'Major Teaching Subjects' in your teacher profile to continue participating in the campaign.",
        },        
        duties:{
            description: "Please select the 'Major Duties' in your teacher profile to continue participating in the campaign.",
        },        
        interests:{
            description: "Please select the 'Areas of Interest' in your teacher profile to continue participating in the campaign.",
        },
        finish:{
            message: "Finished!",
            errorMessage: "An error occurred, please try again later.",
            shareMessage: "Share it with other teachers now and invite them to join the event together to unlock more rewards!​​",            
            share: {
                copy:{
                    title: "Referral code copied",
                },
                copyLink:{
                    title: "Referral link copied",
                },
                instantMessage:{
                    title: "Update your EdCity school-based teacher account now and earn e-vouchers!",
                    content: "Simply complete the data verification to join the campaign and receive e-vouchers. The process is quick and easy. Act now to unlock your exclusive teacher rewards! Referral code: "
                },
                email: {
                subject: "{fullname} wants to invite you to activate your EdCity teacher account and earn E-Vouchers!!",
                content: "Hello! \n \n {fullname} wants to invite you to activate your EdCity teacher account and earn E-Vouchers. Please click the link below, log in to your teacher account, and update your teacher profile:\n {campaignLink} \n \n {fullname}",
                },
            },
        }
    },
    button: {
        join: "Join Now",
        skip: "Skip",
        share: "Share Referral Code",
        cancel: "Cancel",
        next: "Next",
        copy:"Share",
        email: "Email",
        close: "Close",
        learnMore: "Learn More",
        loginAgain: "Login again"
    },
    stepTitle: {
        referree: "Referral Code",
        subscription: "Subscription",
        teacherProfile: "Teacher Profile",
        questionnaire: "Questionnaire",
        complete: "Complete",
    },
  questionnaire: {
    other: "Other",
    errors: {
      required: "This question is required.",
      otherRequired: "Please enter a value for Other.",
    },
    groups: [
      {
        title: "Part I: Awareness of EdCity Activities/Services",
        questions: [
          {
            title: "1.	Please rate your level of awareness and understanding of the following EdCity activities/services (1 = Not aware at all, 5 = Very aware)",
            subtitle: "Item",
            options: [
              { label: "Learning & Teaching Expo (LTE)" },
              { label: "Seminars/Workshops under \"Digital Education Teacher Professional Development\" Series" },
              { label: "Resources Depository (RD)" },
              { label: "STAR - Online Learning, Teaching & Assessment Platform" },
              { label: "Online Question Bank (OQB)" },
              { label: "Go e-Learning" },
              { label: "Digital Education Resources Website" },
              { label: "EdMarket - One-Stop EdTech Hub " },
              { label: "e-Learning Ancillary Facilities Programme (eLAFP)" },
              { label: "PICCKS Student Scheme" },
              { label: "National Identity Mobile App Design Competition (NI)" },
              { label: "Creative Speech Competition (CSC)" },
              { label: "Student Innovation Competition (SIC)" },
              { label: "HK Reading City" },
              { label: "eRead Scheme" },
              { label: "Small Campus" },
              { label: "EdCity Teacher App \"EdCity Teacher\"" },
              { label: "EdCity Student App \"EdCity Student\"" },
              { label: "EdCity Parent App \"EdCity Parent\"" },
              { label: "Parent Seminars" }
            ]
          }
        ]
      },
      {
        title: "Part II: Satisfaction",
        questions: [
          {
            title: "2.	Overall, how satisfied are you with EdCity's current activities and services?",
            options: [
              { label: "Very satisfied" },
              { label: "Satisfied" },
              { label: "Neutral" },
              { label: "Unsatisfied" },
              { label: "Very unsatisfied" }
            ]
          }
        ]
      },
      {
        title: "Part III: Expectations for Student Services & Activities",
        questions: [
          {
            title: "3. What types of activities or services would you like EdCity to offer for students? (Select all that apply)",
            groups: [
              {
                subtitle: "Technology & Digital Literacy",
                options: [
                  { label: "AI / Artificial Intelligence Fundamentals & Applications" },
                  { label: "Coding / Computational Thinking" },
                  { label: "Cybersecurity / Digital Citizenship" },
                  { label: "Multimedia Creation (Videos, Animation, Web Design, etc.)" },
                  { label: "Robotics / STEM / STEAM" },
                ]
              },
              {
                subtitle: "Academic & Language",
                options: [
                  { label: "Science Inquiry" },
                  { label: "Mathematical Thinking" },
                  { label: "Reading & Writing" },
                  { label: "Language Learning (e.g., English & Putonghua)" },
                ]
              },
              {
                subtitle: "Future Planning & Values",
                options: [
                  { label: "Further Studies Guidance" },
                  { label: "National Identity / Chinese Culture" },
                  { label: "Financial Education" },
                  { label: "Values Education (Perseverance, Integrity, Responsibility, etc.)" },
                ]
              },
              {
                subtitle: "Physical & Mental Health",
                options: [
                  { label: "Mental Health / Emotional Management" },
                  { label: "Sports" },
                  { label: "Healthy Eating & Lifestyle" },
                ]
              },
              {
                subtitle: "Others",
                options: []
              }
            ]
          },
          {
            title: "4. What formats would you like EdCity to adopt for student activities in the future? (Select all that apply)",
            groups: [
              {
                subtitle: "Online Formats",
                options: [
                  { label: "Online Workshops" },
                  { label: "Online Seminars" },
                  { label: "Online Competitions" },
                  { label: "Self-Learning Courses (Videos/Materials)" },
                ]
              },
              {
                subtitle: "Offline Formats",
                options: [
                  { label: "In-person Workshops" },
                  { label: "In-person Seminars" },
                  { label: "Competitions" },
                  { label: "Corporate Visits (Local)" },
                  { label: "Corporate Visits (Mainland China/Overseas)" },
                  { label: "Outdoor Learning Days" },
                ]
              },
              {
                subtitle: "Hybrid & Other Formats",
                options: [
                  { label: "Hybrid (Online + Offline)" },
                  { label: "Gamified Learning Activities" },
                  { label: "Simulation Experiences (e.g., Mock Society, Mock Trial)" },
                ]
              },
              {
                subtitle: "Others",
                options: []
              }
            ]
          }
        ]
      },
      {
        title: "Part IV: Expectations for Teacher Professional Development Activities",
        questions: [
          {
            title: "5. What topics are you interested in for teacher professional development activities? (Select all that apply)",
            groups: [
              {
                subtitle: "Teaching & Technology",
                options: [
                  { label: "AI Teaching Tools & Applications" },
                  { label: "EdTech Trends & Innovations" },
                  { label: "AI Digital Literacy" },
                  { label: "Data Analysis & Assessment" },
                  { label: "e-Learning Resource Design" },
                ]
              },
              {
                subtitle: "Professional Skills Enhancement",
                options: [
                  { label: "Curriculum Design & Development" },
                  { label: "Innovative Pedagogies (e.g., Self-Directed Learning, Flipped Classroom)" },
                  { label: "Assessment & Examination Strategies" },
                  { label: "Teacher Management" },
                  { label: "School Administration" },
                  { label: "Education Policies & Development" },
                ]
              },
              {
                subtitle: "Student Support",
                options: [
                  { label: "Classroom Management" },
                  { label: "Mental Health / Student Counselling" },
                  { label: "Career & Life Planning Education" },
                  { label: "Special Educational Needs (SEN)" },
                ]
              },
              {
                subtitle: "Values & Perspectives",
                options: [
                  { label: "National Education / National Security" },
                  { label: "Media & Information Literacy" },
                  { label: "International Perspectives" },
                  { label: "Teacher Well-being (e.g., Stress Management, Work-Life Balance)" },
                ]
              },
              {
                subtitle: "Others",
                options: []
              }
            ]
          },
          {
            title: "6. What activity formats are you interested in? (Select all that apply)",
            groups: [
              {
                subtitle: "Offline Formats",
                options: [
                  { label: "In-person Workshops" },
                  { label: "In-person Seminars / Conferences" },
                  { label: "Local Corporate Visits & Exchanges" },
                  { label: "Mainland China Corporate Visits & Exchanges" },
                  { label: "Sharing Sessions with Fellow Educators" },
                  { label: "Solution Showcases" },
                ]
              },
              {
                subtitle: "Online Formats",
                options: [
                  { label: "Online Seminars" },
                  { label: "Online Workshops" },
                  { label: "Self-Learning Courses (Videos/Materials)" },
                ]
              },
              {
                subtitle: "Hybrid & Other Formats",
                options: [
                  { label: "Hybrid (Online + Offline)" },
                  { label: "Teacher Community Groups" },
                ]
              },
              {
                subtitle: "Others",
                options: []
              }
            ]
          }
        ]
      },
      {
        title: "Part V: Open-ended Feedback (Optional)",
        questions: [
          {
            title: "7.	Do you have any suggestions or ideas for EdCity's future activities or services?"
          }
        ]
      }
    ]
  }

}